import * as React from "react";
import { useTheme } from "@emotion/react";
import { forwardRef } from "react";
import { css, cx } from "@emotion/css";
const SvgSkipPrevious = forwardRef(({
  title,
  titleId,
  desc,
  descId,
  ...props
}, ref) => {
  const theme = useTheme();
  let {
    color,
    colorSecondary,
    size,
    sizeH,
    sizeW,
    height: heightProp,
    width: widthProp,
    shadow,
    animatedProps,
    hex,
    ...other
  } = props;
  const height = heightProp ?? theme.iconSizes?.[sizeH ?? size];
  if (height) {
    other.height = height;
  }
  const width = widthProp ?? theme.iconSizes?.[sizeW ?? size];
  if (width) {
    other.width = isNaN(width) ? "100%" : width;
  }
  let fill = other.fill ?? theme.color?.icon[color];
  let fillSecondary = other.fillSecondary ?? theme.color?.icon[colorSecondary];
  const { className: classNameProp } = other;
  const className = css({
    filter: shadow ? theme.shadows.drop : void 0,
    minHeight: height,
    minWidth: width,
    clipPath: hex ? "url(#rounded-hex-clip-path)" : void 0
  });
  other.className = cx(className, classNameProp);
  if (color === "heading") {
    fill = "url(#harmony-gradient)";
  }
  ;
  other.role = title ? "img" : void 0;
  other["aria-hidden"] = title ? void 0 : true;
  props = {
    ...other,
    ref,
    fill,
    fillSecondary
  };
  return /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": titleId, "aria-describedby": descId, ...props }, desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.36364 17C2.61052 17 2 16.4564 2 15.7857V8.21427C2 7.54365 2.61052 7 3.36364 7C4.11675 7 4.72727 7.54365 4.72727 8.21427V10.9573L12.3726 7.10799C12.8236 6.88094 13.3711 7.024 13.6483 7.42383L13.7073 7.5206C13.7802 7.65744 13.8182 7.80927 13.8182 7.96335L13.8182 10.7391L20.6339 7.10799C21.0601 6.88094 21.5775 7.024 21.8395 7.42383L21.8953 7.5206C21.9641 7.65744 22 7.80927 22 7.96335V16.0369C22 16.5688 21.581 17 21.0641 17C20.9144 17 20.7668 16.963 20.6339 16.8922L13.8182 13.2618V16.0369C13.8182 16.5333 13.4319 16.9421 12.9357 16.9943L12.8278 17C12.6694 17 12.5133 16.963 12.3726 16.8922L4.72727 13.0436V15.7857C4.72727 16.4169 4.18647 16.9356 3.49496 16.9944L3.36364 17Z", fill: props.fill }));
});
export default SvgSkipPrevious;
